import { useToastDataContext } from "../../storages/toastDataProvider";

export const useToast = () => {
  const ctx = useToastDataContext();;
  if (!ctx) {
    throw Error(
      "The `useToasts` hook must be called from a descendent of the `ToastProvider`."
    );
  }
  
  return {
    addToast: ctx.addToast,
  };
};